module.exports = "/_next/static/images/DeepenUnderstanding@2x-eb37f07ea7eecef44c704f6a61333c1e.png";